module.exports = __webpack_public_path__ + "static/media/ua.c9e74f29.svg";